import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const LICENSE_COUNTDOWN_SUCCESS = "LICENSE_COUNTDOWN_SUCCESS";
export const LICENSE_COUNTDOWN_ERROR = "LICENSE_COUNTDOWN_ERROR";

// Thunk Action Creator
export const getExpiryCountdown = createAsyncThunk(
  "api/Licence/expiryCountdown",
  async (_, { dispatch }) => {

       await axios.post(
           `${import.meta.env.VITE_PUBLIC_DOMAIN}Licence/expiryCountdown`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
       )
        .then(response => {
            dispatch({ type: LICENSE_COUNTDOWN_SUCCESS, payload: response.data });
        })
           .catch(error => {
               dispatch({ type: LICENSE_COUNTDOWN_ERROR, payload: error });            
        });
  }
);
